<script>
    import { info, credits } from '../store';
    import { numberFormatter, reset, PMT, calculate } from '../functions';
    import _ from 'lodash';
    import Step6 from './Step6.svelte';
    import Step1 from './Step1.svelte';

    export let step;
    export let stepComponent;

    $credits = calculate($info, $credits);

    let credits_sorted = _.orderBy($credits, ['loan_amount'], ['asc']);
    let longest_credit = _.maxBy($credits, 'duration');
    let max_duration = longest_credit.duration;
    let longest_credit_optimized = _.maxBy($credits, 'duration_optimized');
    let max_duration_optimized = longest_credit_optimized.duration_optimized;

    let initialAmountPaid = _.sumBy($credits, function (credit) {
        return _.sum(credit.monthly_total);
    });
    let initialInterestPaid = _.sumBy($credits, function (credit) {
        return _.sum(credit.monthly_interest);
    });

    let optimizedAmountPaid = _.sumBy($credits, function (credit) {
        return _.sum(credit.monthly_total_optimized);
    });
    let optimizedInterestPaid = _.sumBy($credits, function (credit) {
        return _.sum(credit.monthly_interest_optimized);
    });

    function resetApp () {
        reset();
        $credits = [
            {
                name: '',
                loan_amount: '',
                duration: '',
                interest_rate: '',
                interest_rate_annually: 0,
                monthly_payment: 0,
                amount_paid: 0,
                interest_paid: 0,
            }
        ];
        $info = { name: '', income: 0, hours_month: 168, result_income_hour: 0, level_indebtedness: 0, amount_money_paid_once: 0, amount_money_paid_monthly: 0, spending_hours_in_advance: 0, payment_option_credit: null };
        step = 1;
        stepComponent = Step1;
    }

    function prev () {
        step = 6;
        stepComponent = Step6;
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-7">
        <div class="text-center color-mov mb-4">
            <h2>Ce se întâmplă acum?</h2>
        </div>

        <div class="container-1000">
            <div class="subtitle text-center color-mov mb-4">Am plecat de la situația asta:</div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th>Nume credit</th>
                        <th>Suma</th>
                        <th>Durata</th>
                        <th>Rata dobânzii</th>
                        <th>Rata lunară</th>
                        <th>Suma totală</th>
                        <th>Dobânda plătită</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each $credits as credit}
                        <tr>
                            <td><input type="text" class="input-table small" readonly value="{credit.name}"></td>
                            <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(credit.loan_amount)}"></td>
                            <td><input type="text" class="input-table small text-center" readonly value="{credit.duration}"></td>
                            <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(credit.interest_rate)}"></td>
                            <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(credit.monthly_payment)}"></td>
                            <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(credit.amount_paid)}"></td>
                            <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(credit.interest_paid)}"></td>
                        </tr>
                    {/each}
                    <tr class="last-row">
                        <td><strong>TOTAL</strong></td>
                        <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(_.sumBy($credits, 'loan_amount'))}"></td>
                        <td></td>
                        <td></td>
                        <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(_.sumBy($credits, 'monthly_payment'))}"></td>
                        <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(_.sumBy($credits, 'amount_paid'))}"></td>
                        <td><input type="text" class="input-table text-right" readonly value="{numberFormatter(_.sumBy($credits, 'interest_paid'))}"></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center color-mov mb-4">
                {#if $info.payment_option === 'once'}
                    <p>Am ales să plătesc anticipat suma de <b>{numberFormatter($info.amount_money_paid_once)}</b> pentru a achita
                        {#if $info.payment_option_credit === 'smallest_credit'}
                            datoria cea mai mică.
                        {:else if $info.payment_option_credit === 'biggest_interest'}
                            creditul cu dobânda cea mai mare.
                        {/if}
                    </p>
                {:else if $info.payment_option === 'monthly' }
                    <p>Am ales să plătesc lunar suma de <b>{numberFormatter($info.amount_money_paid_monthly)}</b> pentru a achita
                        {#if $info.payment_option_credit === 'smallest_credit'}
                            datoria cea mai mică.
                        {:else if $info.payment_option_credit === 'biggest_interest'}
                            creditul cu dobânda cea mai mare.
                        {/if}
                    </p>
                {/if}
            </div>

            <div class="text-center color-mov mb-4">
                Rezultatul eforturilor tale este:
            </div>

            <div class="text-center color-mov mb-4">
                Termini toate datoriile de plătit în <strong>{max_duration_optimized} luni</strong>.<br>
                {#if initialInterestPaid - optimizedInterestPaid > 0.01}
                    Economisești dobânda în valoare de <strong>{numberFormatter(initialInterestPaid - optimizedInterestPaid)}</strong>, adică <strong>{max_duration - max_duration_optimized} luni</strong> lucrătoare din viața ta.<br>
                {/if}
                <hr>
            </div>

            <div class="row">
                <div class="col-lg mb-4 text-center">
                    <div class="color-orange text-center"><h4>Varianta inițială</h4></div>

                    <div class="bloc-border-orange">
                        {$credits.length} credite
                    </div>
                    <div class="bloc-border-orange">
                        {max_duration} luni
                    </div>
                    <div class="bloc-border-orange">
                        {numberFormatter(_.sumBy($credits, 'loan_amount'))} de înapoiat
                    </div>
                    <div class="bloc-border-orange">
                        {numberFormatter(_.sumBy($credits, 'monthly_payment'))} de plată lunar
                    </div>
                    <div class="bloc-border-orange">
                        Vei plăti în total <strong>{numberFormatter(initialAmountPaid)}</strong> din care <strong>{numberFormatter(initialInterestPaid)}</strong> dobânda
                    </div>
                </div>
                <div class="col-lg mb-4 text-center">
                    <div class="color-orange"><h4>Varianta finală</h4></div>

                    <div class="bloc-border-orange">
                        {$credits.length} credite
                    </div>
                    <div class="bloc-border-orange">
                        {max_duration_optimized} luni
                    </div>
                    <div class="bloc-border-orange">
                        {numberFormatter(_.sumBy($credits, 'loan_amount'))} de înapoiat
                    </div>
                    <div class="bloc-border-orange">
                        {#if $info.payment_option === 'once'}
                            {numberFormatter(_.sumBy($credits, 'monthly_payment'))} de plată lunar
                        {:else if $info.payment_option === 'monthly' }
                            {numberFormatter(_.sumBy($credits, 'monthly_payment') + $info.amount_money_paid_monthly)} de plată lunar
                        {/if}
                    </div>
                    <div class="bloc-border-orange">
                        Vei plăti în total <strong>{numberFormatter(optimizedAmountPaid)}</strong> din care <strong>{numberFormatter(optimizedInterestPaid)}</strong> dobânda
                    </div>
                </div>
            </div>


            <div class="tabs-container">
                <a href="#VariantaInitiala" class="tab-bt active">Varianta inițială</a>
                <a href="#VariantaFinala" class="tab-bt">Varianta finală</a>
            </div>
            <div class="tab-content" id="VariantaInitiala">
                <div class="table-responsive">
                    <table class="table">
                        <thead style="display: block;">
                        <tr>
                            <th style="width:2%; text-align: right !important;">Luna</th>
                            {#each credits_sorted as credit}
                                <th style="text-align: center !important; width: {(100 / $credits.length) - 1}%;">{credit.name}</th>
                            {/each}
                        </tr>
                        </thead>
                        <tbody style="display: block; max-height: 350px; overflow-y: auto; overflow-x: hidden;">
                        {#each Array(max_duration) as _,row}
                            <tr>
                                <td style="width:2%; text-align: right !important;">{row + 1}</td>
                                {#each credits_sorted as credit}
                                    <td style="text-align: right !important; width: {(100 / $credits.length) - 1}%;">{numberFormatter(credit.monthly_total[row])}</td>
                                {/each}
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="tab-content" id="VariantaFinala" style="display: none">
                <div class="table-responsive">
                    <table class="table">
                        <thead style="display: block;">
                        <tr>
                            <th style="width:2%; text-align: right !important;">Luna</th>
                            {#each credits_sorted as credit}
                                <th style="text-align: center !important; width: {(100 / $credits.length) - 1}%;">{credit.name}</th>
                            {/each}
                        </tr>
                        </thead>
                        <tbody style="display: block; max-height: 350px; overflow-y: auto; overflow-x: hidden;">
                        {#each Array(max_duration_optimized) as _,row}
                            <tr>
                                <td style="width:2%; text-align: right !important;">{row + 1}</td>
                                {#each credits_sorted as credit}
                                    <td style="text-align: right !important; width: {(100 / $credits.length) - 1}%;">{numberFormatter(credit.monthly_total_optimized[row])}</td>
                                {/each}
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{prev}">
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{resetApp}">
                <div class="lab">Resetare</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
